import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";

import styles from "./Filters.module.css";
import { setFilters } from "../../store/actions/TicketsActions";
import { getCardType, getCardStatus } from "../../config";
import { queryStore } from "../../store/actions/UserActions";

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasChange: false,
      active: false,
    };

    this.filters = {
      CardTypeID: [],
      CardStatusID: []
    }

    this.renderFilters = {
      Type: {
        key: "CardTypeID",
        values: [1, 2, 3]
      },
      Status: {
        key: "CardStatusID",
        values: [3, 4]
      }
    }
  }

  onCheckboxChange = (e, key, value) => {
    // add filter if checkbox is checked
    if(e.target.checked) {
      if(!this.filters[key].includes(value)) {
        this.filters[key].push(value);
      }

    // remove previous data in filter
    } else {
      _.remove(this.filters[key], (val) => val === value);
    }

    // this.props.reset();
    // this.props.setFilters(this.filters);
    this.props.setFilters( this.filters );
  }

  render() {
    let filters = this.renderFilters;
    return (
      <div className={styles.filter_container}>
        <label>Status</label>
        <div className={styles.check_list}>
          {filters.Status.values.map(s => {
            return (
              <label key={s}>
                <input type="checkbox" onChange={e => this.onCheckboxChange(e, filters.Status.key, s)} />
                {getCardStatus(s)}
              </label>
            );
          })}
        </div>
        <label>Payment Method</label>
        <div className={styles.check_list}>
          {filters.Type.values.map(t => {
            return (
              <label key={t}>
                <input type="checkbox" onChange={e => this.onCheckboxChange(e, filters.Type.key, t)} />
                {getCardType(t)}
              </label>
            );
          })}
        </div>
      </div>
    );
  }
}

function mapStateToProps(store) {
  return {
    //storeName: reducerName
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // setFilters: bindActionCreators(setFilters, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filters);
